import Loading from '@/shared/components/Carregando';
import { AnoReferenciaAbonoEspecial, DataAmigavel, PeriodosAquisitos } from '@/shared/utils/datas';
import { Fragment, useEffect, useState } from 'react';
import { GetRelatorioDefensores } from '@/modules/reports/relatorio.service';
import { TipoPeriodoDescanso } from '../enums/tipo-periodo-descanso.enum';
import { toast } from 'react-toastify';
import { ReadDefensorResponseDto } from '@/api.types';

interface IMyProps {
  todoperiodo: boolean;
  tiposEventos?: number[];
  dataInicial?: string;
  dataFinal?: string;
}

export default function RelatorioFeriasContent({
  todoperiodo,
  tiposEventos,
  dataInicial,
  dataFinal,
}: IMyProps) {
  const [loading, setLoading] = useState<boolean>(true);
  const [registros, setRegistros] = useState<ReadDefensorResponseDto[]>([]);

  useEffect(() => {
    GetRelatorioDefensores(todoperiodo, tiposEventos, dataInicial, dataFinal)
      .then((result) => {
        setRegistros(result);
        setLoading(false);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, [todoperiodo, tiposEventos, dataInicial, dataFinal]);

  function TipoExtenso(tipo: TipoPeriodoDescanso) {
    switch (tipo) {
      case TipoPeriodoDescanso.Ferias:
        return 'Férias';
      case TipoPeriodoDescanso.FolgaNatalicia:
        return 'Folga Natalícia';
      case TipoPeriodoDescanso.AbonoTrabalhado:
        return 'Abono Trabalhado';
      case TipoPeriodoDescanso.AbonoEspecial:
        return 'Abono Especial';
      case TipoPeriodoDescanso.LicencaPremio:
        return 'Licença Prêmio';
      case TipoPeriodoDescanso.LicencaOutros:
        return 'Afastado';
      // case TipoPeriodoDescanso.Afastamento:
      // 	break;
      default:
        return 'Trabalhando';
    }
  }

  function ExibirDataAquisitiva(
    tipo: TipoPeriodoDescanso | undefined,
    data_aquisitiva: Date | string | undefined,
  ) {
    switch (tipo) {
      case TipoPeriodoDescanso.Ferias:
      case TipoPeriodoDescanso.LicencaPremio:
        return (
          <Fragment>{PeriodosAquisitos(new Date(data_aquisitiva!))}</Fragment>
        );
      case TipoPeriodoDescanso.AbonoEspecial:
        return (
          <Fragment>
            {AnoReferenciaAbonoEspecial(data_aquisitiva!)}
          </Fragment>
        );
      case TipoPeriodoDescanso.FolgaNatalicia:
      case TipoPeriodoDescanso.AbonoTrabalhado:
      case TipoPeriodoDescanso.LicencaOutros:
        // case TipoPeriodoDescanso.Afastamento:
        return <Fragment>{DataAmigavel(data_aquisitiva)}</Fragment>;
      default:
        return <Fragment>{DataAmigavel(data_aquisitiva)}</Fragment>;
    }
  }

  if (loading) return Loading();

  return (
    <div id="conteudo" className="table-responsive">
      <table
        id="tabela"
        className="table table-sm table-striped table-hover mt-2"
      >
        <thead className="">
          <tr className="justify-content-center">
            <th scope="col">Defensor</th>
            <th scope="col">Eventos</th>
          </tr>
        </thead>
        <tbody className="table-group-divider ">
          {registros &&
            registros.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.pessoa?.nome}</td>
                  <td>
                    <Fragment>
                      {item.periodos?.map(
                        (
                          subItem,
                          index2, //
                        ) => {
                          return (
                            <Fragment key={index2}>
                              <span>
                                {TipoExtenso(
                                  subItem.tipo as TipoPeriodoDescanso,
                                )}{' '}
                                no período de{' '}
                                <b className="fw-bold">
                                  {DataAmigavel(subItem.data_inicial)}
                                </b>{' '}
                                a <b>{DataAmigavel(subItem.data_final)}</b>{' '}
                                referente a
                                <b>
                                  {' '}
                                  {ExibirDataAquisitiva(
                                    subItem.tipo,
                                    subItem.data_aquisitiva,
                                  )}
                                </b>{' '}
                                {subItem.exibiranotacao && subItem.motivo}
                              </span>
                              <br />
                            </Fragment>
                          );
                        },
                      )}
                    </Fragment>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
